import React from 'react'
import Spinner from 'react-bootstrap/Spinner';


const Index = () => {
  return (
    <div className='max-loader'>
    <Spinner animation="border" role="status">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
    </div>
  )
}

export default Index